import React, { useState, useEffect, useReducer } from "react";
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../common/storeContext';
import { Modal, Nav, Form } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { BsExclamationCircleFill } from "react-icons/bs"
import { useMiddletier } from "../common/middletier";
import { TENANT_BUCKET, COUNTRY_LIST } from '../common/constants'
import { useNavigate } from "react-router-dom";
import Alert from './Alert'
import Loading from './Loading';

import './AddressDialog.css';
import { useForm } from "react-hook-form";


const AddAddressDialog = (props) => {
  const { defaultContent, getData } = props
  const { t } = useTranslation();
  const { query, mutation } = useMiddletier()
  const appState = useStoreState()
  const appDispatch = useStoreDispatch()
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false)
  const [address, setAddress] = useState([])
  const [selectedAddress, setSelectedAddress] = useState('')
  const [dialCode, setDialCode] = useState("");
  const [showAddAddress, setShowAddAddress] = useState(false)

  const {
    register,
    setValue,
    getValues,
    reset,
    formState: { errors, isValid },
    watch,
    handleSubmit,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      country: appState?.country ?? ''
    }
  });

  const getCurrentCountryCode=watch('country')


  useEffect(() => {
    if (props.show) {
      console.log('defaultContent', defaultContent)

      if (defaultContent === 'first_add' || defaultContent === 'userInfo_add' || defaultContent === 'userInfo_edit') {
        setShowAddAddress(true)

        if (defaultContent === 'userInfo_edit') {
          Object.entries(getData).forEach((item) => {
            const [key, value] = item;
            if (key !== 'id' || key !== 'address') {
              if (key === 'country') {
                let getCountryCode = COUNTRY_LIST.find((e) => e.name === value)?.code
                setValue(`${key}`, getCountryCode ?? '')

              }else if(key==='recipient_phone_number'){
                let getPhoneNumber = value?.startsWith(dialCode) ? value?.slice(dialCode?.length) : value;
                setValue(`${key}`, getPhoneNumber ?? '')
              }else {
                setValue(`${key}`, value)
              }
            }
          });
        } else {

        }
      } else {
        setShowAddAddress(false)
      }
    }
  }, [props.show, defaultContent, getData, setValue])


  useEffect(() => {
    const getCountryDailingCode = COUNTRY_LIST.find((e) => e.code === getCurrentCountryCode)?.dial_code
    setDialCode(getCountryDailingCode || "");
  }, [getCurrentCountryCode]);


  // VALIDATION RULES
  const getValidationRules = (type, t, getValues, appState) => {
    switch (type) {
      case 'username':
        return {
          required: t('error_username_empty'),
          minLength: { value: 6, message: t('error_username_length') },
          maxLength: { value: 12, message: t('error_username_length') },
        };
      case 'password':
        return {
          required: t('error_password_empty'),
          minLength: { value: 6, message: t('error_password_length') },
        };
      case 'confirm_password':
        return {
          required: t('error_confirm_password_empty'),
          minLength: { value: 6, message: t('error_confirm_password_length') },
          validate: (value) => {
            const { password } = getValues();
            return (
              password === value || t('error_confirm_password_matchPassword')
            );
          },
        };
      case 'affiliate':
        return {
          required: false,
          minLength: { value: 6, message: 'Affiliate min length 6' },
          maxLength: { value: 6, message: 'Affiliate max length 6' },
        };
      case 'agreement':
        return {
          required: true,
        };
      case 'fullname':
        return {
          required: t('error_fullname_empty'),
          pattern: { value: /^[A-Za-z\s]+$/i, message: t('error_fullname_format') },
        };
      case 'email':
        return {
          required: appState.registration.emailRequired && t('error_email_empty'),
          pattern: { value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, message: t('error_email_format') },
        };
      case 'code':
        return {
          required: t('error_code_empty'),
        };
      case 'phone_number':
        return {
          required: appState.registration.phoneRequired && t('error_phone_number_empty'),
          // pattern: { value: /^\(?(1[0-9]{1})\)?[-. ]?([0-9]{7,8})$/, message: t('error_phone_number_format') },
          pattern: { value: /^\d{8,}$/, message: t('error_phone_number_format') }
        };
      default:
        return {};
    }
  };

  const changeAddress = (item) => {
    setSelectedAddress(item)
    console.log('item address', item)
  }

  const onClickAddAddress = () => {
    setShowAddAddress(true)
  }

  const submitAddress = () => {
    const values = getValues();
    console.log('values', values)
    let getCountryName = COUNTRY_LIST.find((e) => e.code === values.country)?.name

    console.log('getCountryName', getCountryName)
    setLoading(true);
    if (defaultContent === 'userInfo_edit') {

      mutation([{
        method: 'updateAddressByMember',
        params: [
          { code: 'memberAddress', graphqlType: 'String', required: true, value: getData?.id },
          { code: 'address_name', graphqlType: 'String', required: false, value: values.address_name },
          { code: 'address_line_1', graphqlType: 'String', required: false, value: values.address_line_1 },
          { code: 'address_line_2', graphqlType: 'String', required: false, value: values.address_line_2 },
          { code: 'address_line_3', graphqlType: 'String', required: false, value: values.address_line_3 },
          { code: 'postal_code', graphqlType: 'Int', required: false, value: parseInt(values.postal_code) },
          { code: 'city', graphqlType: 'String', required: false, value: values.city },
          { code: 'state', graphqlType: 'String', required: false, value: values.state },
          { code: 'country', graphqlType: 'String', required: false, value: getCountryName },
          { code: 'recipient_phone_number', graphqlType: 'String', required: false, value: `${dialCode}${values.recipient_phone_number}` },
        ],
        attributes: []

      }])
        .then(({ data }) => {
          console.log(data['updateAddressByMember'])
          query({
            method: 'getMemberAddress',
            params: [],
            attributes: []

          }).then(({ data }) => {
            setLoading(false);
            // setAddress(data['getMemberAddress'])
            appDispatch({
              type: APP_STORE_ACTION.SET_ADDRESS,
              payload: data['getMemberAddress']
            });
            // }
            if (defaultContent === 'userInfo_edit') {
              appDispatch({
                type: APP_STORE_ACTION.SHOW_ALERT,
                payload: { description: 'Edit Successful', typeAlert: 'success' }
              });

              props.onHide()
            }

          }).catch((error) => {
            if (error?.networkError?.statusCode === 401) {
              appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
            } else {
              if (error.toString().includes("No Access Token") || error.toString().includes("tokens")) {
                appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
              } else {
                appDispatch({
                  type: APP_STORE_ACTION.SHOW_ALERT,
                  payload: { description: error.message.toString(), typeAlert: 'error' }
                });
              }

            }
          })
          setShowAddAddress(false)

        })
        .catch((error) => {
          setLoading(false);
          if (error?.networkError?.statusCode === 401) {
            appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
          } else {
            appDispatch({
              type: APP_STORE_ACTION.SHOW_ALERT,
              payload: { description: error.message.toString(), typeAlert: 'error' }
            });
          }
        })
    } else {
      mutation([{
        method: 'createAddressByMember',
        params: [
          { code: 'address_name', graphqlType: 'String', required: true, value: values.address_name },
          { code: 'address_line_1', graphqlType: 'String', required: true, value: values.address_line_1 },
          { code: 'address_line_2', graphqlType: 'String', required: false, value: values.address_line_2 },
          { code: 'address_line_3', graphqlType: 'String', required: false, value: values.address_line_3 },
          { code: 'postal_code', graphqlType: 'Int', required: true, value: parseInt(values.postal_code) },
          { code: 'city', graphqlType: 'String', required: true, value: values.city },
          { code: 'state', graphqlType: 'String', required: true, value: values.state },
          { code: 'country', graphqlType: 'String', required: true, value: getCountryName },
          { code: 'isDefault', graphqlType: 'Boolean', required: false, value: values.isDefault },
          { code: 'recipient_phone_number', graphqlType: 'String', required: false, value: `${dialCode}${values.recipient_phone_number}` },
        ],
        attributes: []

      }])
        .then(({ data }) => {
          console.log(data['createAddressByMember'])
          query({
            method: 'getMemberAddress',
            params: [],
            attributes: []

          }).then(({ data }) => {
            setLoading(false);
            // setAddress(data['getMemberAddress'])
            appDispatch({
              type: APP_STORE_ACTION.SET_ADDRESS,
              payload: data['getMemberAddress']
            });
            // }
            if (defaultContent === 'userInfo_add') {
              props.onHide()

            }

            if (defaultContent === 'first_add') {
              appDispatch({
                type: APP_STORE_ACTION.SET_SELECTED_ADDRESS,
                payload: data['getMemberAddress'][0]
              });
              setSelectedAddress({})
              props.onHide()
            }
            reset()


          }).catch((error) => {
            if (error?.networkError?.statusCode === 401) {
              appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
            } else {
              if (error.toString().includes("No Access Token") || error.toString().includes("tokens")) {
                appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
              } else {
                appDispatch({
                  type: APP_STORE_ACTION.SHOW_ALERT,
                  payload: { description: error.message.toString(), typeAlert: 'error' }
                });
              }

            }
          })
          setShowAddAddress(false)

        })
        .catch((error) => {
          // console.log('error: ', error)
          setLoading(false);
          if (error?.networkError?.statusCode === 401) {
            appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
          } else {
            appDispatch({
              type: APP_STORE_ACTION.SHOW_ALERT,
              payload: { description: error.message.toString(), typeAlert: 'error' }
            });
          }
        })

    }

  }

  const confirmAddress = () => {
    appDispatch({
      type: APP_STORE_ACTION.SET_SELECTED_ADDRESS,
      payload: Object.keys(selectedAddress).length === 0 && appState?.selectedAddress?.id !== 'undefined' ? appState?.selectedAddress : selectedAddress
    });
    setSelectedAddress({})
    props.onHide()
  }

  const onHideAddressDialog = () => {
    props.onHide()
  }

  const onHideAddAddressDialog = () => {
    if (defaultContent === 'first_add') {
      appDispatch({
        type: APP_STORE_ACTION.SET_CHECK_ADDRESS,
        payload: true
      });
      props.onHide()
    } else if (defaultContent === 'userInfo_add' || defaultContent === 'userInfo_edit') {
      // resetAddress()
      props.onHide()

    } else {
      setShowAddAddress(false)

    }
    resetAddress()
  }

  const resetAddress = () => {
    reset({
      address_name: '',
      address_line_1: '',
      address_line_2: '',
      address_line_3: '',
      postal_code: '',
      city: '',
      state: '',
      country: appState?.country ?? '',
      recipient_phone_number:'',
      isDefault: false
    });
  }

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="addAddressModal"
        backdropClassName="addAddressBackdrop"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter" className="subTitle">
            {t('My Address')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={`changeAddress_container ${showAddAddress ? 'd-none slide-out' : 'd-block slide-in'}`}>
            {appState.address?.map(function (item) {
              return (
                <div key={item.id} className={`address_container ${item.id === (selectedAddress?.id ?? appState?.selectedAddress?.id) && ('active')}`} onClick={() => changeAddress(item)}>
                  <p><b>{appState?.user?.username}</b> | {item.address_name}</p>
                  {item?.recipient_phone_number && (<p>+{item.recipient_phone_number}</p>)}
                  <p>{item.address}</p>
                  {item.isDefault && (<div className="address_default">{t('default')}</div>)}
                </div>
              )
            })}
            <button type="button" onClick={onClickAddAddress} className="color_button font_button button_action">{t('add_address')}</button>
          </div>

          <div className={`addAddress_container ${(showAddAddress) ? 'd-block slide-in' : 'd-none slide-out'}`}>
            <div className="myAddress_title">{t('add_address')}</div>
            <Form.Group className="form_field" >
              <div className="form_field_input">
                <Form.Control
                  type="text"
                  name="Address Name"
                  placeholder={t('Address Name')}
                  className="input_address_name"
                  aria-label="_address_name"
                  autoComplete="off"


                  onKeyDown={(event) => {
                    const isSpace = event.key === ' ';
                    const isLetter = /^[a-zA-Z\s]*$/.test(event.key);
                    const inputIsEmpty = event.target.value.length === 0;

                    if ((isSpace && inputIsEmpty) || !isLetter) {
                      event.preventDefault();
                    }
                  }}

                  onInput={(event) => {
                    const isSpace = event.target.value.includes(' ');
                    const inputIsEmpty = event.target.value.trim().length === 0;

                    if (isSpace && inputIsEmpty) {
                      event.target.value = event.target.value.replace(/ /g, '');
                    }
                  }}
                  {...register("address_name", getValidationRules('address_name', t))}
                />

              </div>
            </Form.Group>
            <Form.Group className="form_field" >
              <div className="form_field_input">
                <Form.Control
                  type="text"
                  name="address_line_1"
                  placeholder={t('Address Line 1')}
                  className="input_address_line1"
                  aria-label="address_line_1"
                  autoComplete="off"

                  onKeyDown={(event) => {
                    const isSpace = event.key === ' ';
                    // const isLetter = /^[a-zA-Z\s]*$/.test(event.key);
                    const inputIsEmpty = event.target.value.length === 0;

                    if ((isSpace && inputIsEmpty)) {
                      event.preventDefault();
                    }
                  }}

                  onInput={(event) => {
                    const isSpace = event.target.value.includes(' ');
                    const inputIsEmpty = event.target.value.trim().length === 0;

                    if (isSpace && inputIsEmpty) {
                      event.target.value = event.target.value.replace(/ /g, '');
                    }
                  }}
                  {...register("address_line_1", getValidationRules('address_line_1', t))}
                />

              </div>
            </Form.Group>
            <Form.Group className="form_field" >
              <div className="form_field_input">
                <Form.Control
                  type="text"
                  name="address_line_2"
                  placeholder={t('Address Line 2')}
                  className="input_address_line2"
                  aria-label="_address_line2"
                  autoComplete="off"

                  onKeyDown={(event) => {
                    const isSpace = event.key === ' ';
                    // const isLetter = /^[a-zA-Z\s]*$/.test(event.key);
                    const inputIsEmpty = event.target.value.length === 0;

                    if ((isSpace && inputIsEmpty)) {
                      event.preventDefault();
                    }
                  }}

                  onInput={(event) => {
                    const isSpace = event.target.value.includes(' ');
                    const inputIsEmpty = event.target.value.trim().length === 0;

                    if (isSpace && inputIsEmpty) {
                      event.target.value = event.target.value.replace(/ /g, '');
                    }
                  }}
                  {...register("address_line_2", getValidationRules('address_line_2', t))}
                />

              </div>
            </Form.Group>
            <Form.Group className="form_field" >
              <div className="form_field_input">
                <Form.Control
                  type="text"
                  name="address_line_3"
                  placeholder={t('Address Line 3')}
                  className="input_address_line_3"
                  aria-label="address_line_3"
                  autoComplete="off"

                  onKeyDown={(event) => {
                    const isSpace = event.key === ' ';
                    // const isLetter = /^[a-zA-Z\s]*$/.test(event.key);
                    const inputIsEmpty = event.target.value.length === 0;

                    if ((isSpace && inputIsEmpty)) {
                      event.preventDefault();
                    }
                  }}

                  onInput={(event) => {
                    const isSpace = event.target.value.includes(' ');
                    const inputIsEmpty = event.target.value.trim().length === 0;

                    if (isSpace && inputIsEmpty) {
                      event.target.value = event.target.value.replace(/ /g, '');
                    }
                  }}
                  {...register("address_line_3", getValidationRules('address_line_3', t))}
                />

              </div>
            </Form.Group>
            <Form.Group className="form_field" >
              <div className="form_field_input">
                <Form.Control
                  type="text"
                  name="Postal Code"
                  placeholder={t('Postal Code')}
                  className="input_postal_code"
                  aria-label="input_postal_code"
                  autoComplete="off"
                  onKeyDown={(event) => {
                    if (event.key === ' ') {
                      event.preventDefault();
                    }
                  }}
                  onInput={(event) => {
                    if (event.target.value.includes(' ')) {
                      event.target.value = event.target.value.replace(/ /g, '');
                    }
                    event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
                  }}
                  {...register("postal_code", getValidationRules('postal_code', t))}
                />

              </div>
            </Form.Group>
            <Form.Group className="form_field" >
              <div className="form_field_input">
                <Form.Control
                  type="text"
                  name="city"
                  placeholder={t('City')}
                  className="input_city"
                  aria-label="city"
                  autoComplete="off"

                  onKeyDown={(event) => {
                    const isSpace = event.key === ' ';
                    const isLetter = /^[a-zA-Z\s]*$/.test(event.key);
                    const inputIsEmpty = event.target.value.length === 0;

                    if ((isSpace && inputIsEmpty) || !isLetter) {
                      event.preventDefault();
                    }
                  }}

                  onInput={(event) => {
                    const isSpace = event.target.value.includes(' ');
                    const inputIsEmpty = event.target.value.trim().length === 0;

                    if (isSpace && inputIsEmpty) {
                      event.target.value = event.target.value.replace(/ /g, '');
                    }
                  }}
                  {...register("city", getValidationRules('city', t))}
                />

              </div>
            </Form.Group>
            <Form.Group className="form_field" >
              <div className="form_field_input">
                <Form.Control
                  type="text"
                  name="state"
                  placeholder={t('State')}
                  className="input_state"
                  aria-label="state"
                  autoComplete="off"

                  onKeyDown={(event) => {
                    const isSpace = event.key === ' ';
                    const isLetter = /^[a-zA-Z\s]*$/.test(event.key);
                    const inputIsEmpty = event.target.value.length === 0;

                    if ((isSpace && inputIsEmpty) || !isLetter) {
                      event.preventDefault();
                    }
                  }}

                  onInput={(event) => {
                    const isSpace = event.target.value.includes(' ');
                    const inputIsEmpty = event.target.value.trim().length === 0;

                    if (isSpace && inputIsEmpty) {
                      event.target.value = event.target.value.replace(/ /g, '');
                    }
                  }}
                  {...register("state", getValidationRules('state', t))}
                />

              </div>
            </Form.Group>
            <Form.Group className="form_field" >
              <div className="form_field_input">
                {/* <Form.Control
                  type="text"
                  name="country"
                  placeholder={t('Country')}
                  className="input_country"
                  aria-label="country"
                  autoComplete="off"
                  onKeyDown={(event) => {
                    if (event.key === ' ') {
                      event.preventDefault();
                    }
                  }}
                  onInput={(event) => {
                    if (event.target.value.includes(' ')) {
                      event.target.value = event.target.value.replace(/ /g, '');
                    }
                    event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
                  }}
                  {...register("country", getValidationRules('country', t))}
                /> */}

                <Form.Select {...register("country", getValidationRules('country', t))}>
                  <option hidden>Select Country</option>
                  {COUNTRY_LIST.map(function (item) {
                    return (
                      <option value={item.code} key={item.code} >{item.name}</option>
                    )
                  })}
                </Form.Select>

              </div>
            </Form.Group>

            <Form.Group className="form_field" >
              <div className="form_field_input">
                <div className="d-flex align-items-center justify-content-center">
                <Form.Control
                  type="text"
                  name="country_dailing_code"
                  className="input_country_dailing_code"
                  aria-label="input_country_dailing_code"
                  autoComplete="off"
                  value={`+${dialCode}`}
                  disabled={true}
                />
              <Form.Control
                  type="text"
                  name="recipient_phone_number"
                  placeholder={t('Recipient Phone Number')}
                  className="input_recipient_phone_number"
                  aria-label="input_recipient_phone_number"
                  autoComplete="off"
                  onKeyDown={(event) => {
                    if (event.key === ' ') {
                      event.preventDefault();
                    }
                  }}
                  onInput={(event) => {
                    if (event.target.value.includes(' ')) {
                      event.target.value = event.target.value.replace(/ /g, '');
                    }
                    event.target.value = event.target.value.replace(/[^0-9]/g, '');
                  }}
                  {...register("recipient_phone_number", getValidationRules('recipient_phone_number', t))}
                />
              </div>
              </div>
            </Form.Group>

            {defaultContent !== 'userInfo_edit' && (<Form.Group className="form_field" >
              <div className="form_field_input">
                <Form.Check type='checkbox' >
                  <Form.Check.Input type='checkbox' {...register("isDefault", { required: false })} />
                  <Form.Check.Label> Default</Form.Check.Label>
                </Form.Check>
              </div>
            </Form.Group>)}
            <div className="addAddress_action">
              <button type="button" onClick={onHideAddAddressDialog} className="color_button font_button btnCancel">Cancel</button>
              <button type="button" onClick={submitAddress} className="color_button font_button button_action">Submit</button></div>
          </div>
        </Modal.Body>
        {(!showAddAddress) && (<Modal.Footer>
          <button className="cancel_button" onClick={onHideAddressDialog}>
            {t('cancel')}
          </button>
          <button className="confirm_button" onClick={confirmAddress}>
            {t('confirm')}
          </button>
        </Modal.Footer>)}
      </Modal>

      {isLoading && (<Loading />)}

    </>
  );
}

export default AddAddressDialog;
